// extracted by mini-css-extract-plugin
export default {"iframe":"dj4t_"};